import { Recording } from "@/models/recording";

export interface Contribution {
    campaignID: string;
    imageURL?: string;
    imageData?: ArrayBuffer;
    email?: string;
    name?: string;
    rating?: number;
    externalID?: string;
    recordings: Recording[];
    conversation: ContributionConversationRound[];
}

export interface ContributionConversationRound {
    question: string;
    transcript?: string;
}

export function totalContributionDuration(contribution: Contribution): number {
    return contribution.recordings.reduce((acc, recording) => acc + recording.duration, 0);
}
